import { useNavigate } from "@tanstack/react-router";
import { Search } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { TextField } from "../../design-system/TextField";

/**
 * Search from anywhere in the shell.
 *
 * Submitting navigates to Discovery with the query in the URL rather than
 * holding results locally, so a search is shareable, survives a reload, and
 * reuses the catalogue surface instead of duplicating it.
 */
export function GlobalSearchField({ className }: { className?: string }) {
  const { t } = useTranslation("foundation");
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  return (
    <form
      aria-label={t("shell.searchLabel")}
      className={["global-search", className].filter(Boolean).join(" ")}
      role="search"
      onSubmit={(event) => {
        event.preventDefault();
        const trimmed = query.trim();
        void navigate({
          to: "/discover/$scope",
          params: { scope: "trending" },
          search: trimmed ? { q: trimmed } : {},
        });
      }}
    >
      <Search aria-hidden="true" className="global-search__icon" size={16} />
      <TextField
        aria-label={t("shell.searchLabel")}
        placeholder={t("shell.searchPlaceholder")}
        type="search"
        value={query}
        onChange={(event) => {
          setQuery(event.target.value);
        }}
      />
    </form>
  );
}
